import React from 'react';
import IntegrationAutosuggestBeneficiario from './IntegrationAutosuggestBeneficiario';
import {FormControl,
  IconButton,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';

const styles = theme => ({
  root: {
    display: 'inline',
  },
  formControlAutoCompleteNome: {
    // minWidth: 500,
    width: theme.spacing.unit * 55,
  },
  formControlAutoCompleteCarteira: {
    // minWidth: 50,
    width: theme.spacing.unit * 23,
  },
  iconButton: {
    marginTop: theme.spacing.unit,
  },
});

class FilterBeneficiario extends React.Component {
  state = {
    carteiraSelected: this.props.carteiraInicial === undefined ? '' : this.props.carteiraInicial,
    nomeBeneficiarioSelected: this.props.nomeInicial === undefined ? '' : this.props.nomeInicial,
    suggestionsCarteira: [],
    suggestionsNome: [],
    exibeSuggestion: true,
    nomes: [],
    carteiras: [],
    limparDisabled: true
  }
  getSuggestionValueNomes = (suggestion, id) => {
    this.setState({exibeSuggestion: true, nomeBeneficiarioSelected: suggestion.id === undefined ? suggestion : suggestion.nome});
    if (id === 0) {
      this.setState({carteiraSelected: ''});
    }
    if (id === undefined) {
      this.setState({carteiraSelected: suggestion.id});
    }
    if (id !== 0 && id !== undefined) {
      this.setState({carteiraSelected: id});
    }
    return suggestion.nome;
  }
  getSuggestionValueCarteiras = (suggestion, id) => {
    this.setState({exibeSuggestion: true, carteiraSelected: suggestion.nome === undefined ? suggestion : suggestion.nome});
    if (id === 0) {
      this.setState({nomeBeneficiarioSelected: ''});
    }
    if (id === undefined) {
      this.setState({nomeBeneficiarioSelected: suggestion.id});
    }
    if (id !== 0 && id !== undefined) {
      this.setState({nomeBeneficiarioSelected: id});
    }
    return suggestion.nome;
  }

  handleChangeCarteira = (name) => (event, { newValue }) => {
    var novoValor = newValue.replace(/[^\d.-]/g, '');
    if (novoValor.length === 5 && event.target.defaultValue.length < 5) {
      novoValor = novoValor + '-';
    }
    if (novoValor.length > 8) {
      novoValor = novoValor.substring(0, 8);
    } else {
      this.setState({
        [name]: novoValor,
      });
      let valor = this.state.suggestionsCarteira.find(obj => obj.nome === novoValor);
      if (event.type === 'click' || event.type === 'keydown' || event.type === 'mouseout') {
        this.setState({nomeBeneficiarioSelected: valor.id, exibeSuggestion: false, limparDisabled: false, carteiraSelected: valor.nome});
        this.props.handleSelectBeneficiario(valor.nome, valor.id);
      } else {
        this.getSuggestionValueCarteiras(novoValor, valor === undefined ? 0 : valor.id, novoValor.toUpperCase());
      }
    }
  }

  handleChangeNome = (name) => (event, { newValue }) => {
    var novoValor = newValue.toUpperCase();
    this.setState({
      [name]: novoValor
    });
    let valor = this.state.suggestionsNome.find(obj => obj.nome === novoValor);
    if (event.type === 'click' || event.type === 'keydown' || event.type === 'mouseout') {
      this.setState({carteiraSelected: valor.id, exibeSuggestion: false, limparDisabled: false, nomeBeneficiarioSelected: valor.nome});
      this.props.handleSelectBeneficiario(valor.id, valor.nome);
    } else {
      this.getSuggestionValueNomes(novoValor, valor === undefined ? 0 : valor.id, novoValor);
    }
  }

  handleOnBlurCarteira = () => {
    if (this.state.nomeBeneficiarioSelected !== '' && this.state.nomeBeneficiarioSelected !== 0) {
      this.setState({exibeSuggestion: false, limparDisabled: false});
      this.props.handleSelectBeneficiario(this.state.carteiraSelected, this.state.nomeBeneficiarioSelected);
    } else {
      this.setState({nomeBeneficiarioSelected: '', carteiraSelected: '', exibeSuggestion: true, limparDisabled: true});
      this.props.handleSelectBeneficiario('', '');
    }
  }

  handleOnBlurNome = () => {
    if (this.state.carteiraSelected !== '' && this.state.carteiraSelected !== 0) {
      this.setState({exibeSuggestion: false, limparDisabled: false});
      this.props.handleSelectBeneficiario(this.state.carteiraSelected, this.state.nomeBeneficiarioSelected);
    } else {
      this.setState({nomeBeneficiarioSelected: '', carteiraSelected: '', exibeSuggestion: true, limparDisabled: true});
      this.props.handleSelectBeneficiario('', '');
    }
  }

  componentDidMount () {
    const nomes = this.props.beneficiarios;
    let carteiras = [];
    let nomesAux = nomes.sort(this.dynamicSort('id'));
    nomesAux.map(nome => {
      let carteira = {id: '', nome: ''};
      carteira.nome = nome.id;
      carteira.id = nome.nome;
      carteiras.push(carteira);
    });
    this.setState({nomes: nomes, carteiras: carteiras, suggestionsCarteira: carteiras, suggestionsNome: nomes});
  }
  dynamicSort (property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    };
  }

  handleClickTrash = () => {
    this.setState({nomeBeneficiarioSelected: '', carteiraSelected: '', limparDisabled: true});
    this.props.handleClickLimpar();
  }

  render () {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <FormControl className={classes.formControlAutoCompleteCarteira}>
          <IntegrationAutosuggestBeneficiario
            exibeSuggestion={this.state.exibeSuggestion}
            name='carteiraSelected'
            single={this.state.carteiraSelected}
            handleChange={this.handleChangeCarteira}
            handleOnBlur={this.handleOnBlurCarteira}
            getSuggestionValue={this.getSuggestionValueCarteiras}
            suggestions={this.state.carteiras}
            placeholder={'Digite a Carteira...'}
            porNome={false}
            porCarteira
            disabled={this.props.disabled}
            maxSuggestions={this.props.maxSuggestions}
          />
        </FormControl>
        <FormControl className={classes.formControlAutoCompleteNome}>
          <IntegrationAutosuggestBeneficiario
            exibeSuggestion={this.state.exibeSuggestion}
            name='nomeBeneficiarioSelected'
            single={this.state.nomeBeneficiarioSelected}
            handleChange={this.handleChangeNome}
            handleOnBlur={this.handleOnBlurNome}
            getSuggestionValue={this.getSuggestionValueNomes}
            suggestions={this.state.nomes}
            placeholder={'Digite o nome do Beneficiário...'}
            porNome
            porCarteira={false}
            disabled={this.props.disabled}
            maxSuggestions={this.props.maxSuggestions}
          />
        </FormControl>
        <FormControl>
          <IconButton
            disabled={this.state.limparDisabled}
            className={classes.iconButton}
            title='Limpar'
            onClick={this.handleClickTrash}
          >
            <DeleteIcon />
          </IconButton>
        </FormControl>
      </div>
    );
  }
}
export default withStyles(styles)(FilterBeneficiario);
